// src/components/Leaderboard.jsx
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import memecoins from '../assets/memecoins.json';

const Leaderboard = ({ coins: externalCoins }) => {
  const [coins, setCoins] = useState([]);

  useEffect(() => {
    if (externalCoins) {
      setCoins(externalCoins);
    } else {
      setCoins(memecoins);
    }
  }, [externalCoins]);

  return (
    <div style={styles.grid}>
      {coins.map((coin) => (
        <Link
          key={coin.id}
          to={`/token/${coin.ticker.replace('$', '').toLowerCase()}`}
          style={styles.cardLink}
        >
          <div style={styles.card}>
            <div style={styles.imagePlaceholder}></div>
            <h3 style={styles.ticker}>{coin.ticker}</h3>
            <p style={styles.contributions}>{coin.contributions} SOL</p>
          </div>
        </Link>
      ))}
    </div>
  );
};

const styles = {
  grid: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: '2rem',
    padding: '2rem',
  },
  cardLink: {
    textDecoration: 'none',
  },
  card: {
    width: '160px',
    padding: '1rem',
    border: '2px solid #00FFFF',
    borderRadius: '8px',
    textAlign: 'center',
    backgroundColor: '#1a1a1a',
    color: '#f0f0f0',
  },
  imagePlaceholder: {
    width: '80px',
    height: '80px',
    backgroundColor: '#333',
    margin: '0 auto 0.5rem',
    borderRadius: '4px',
  },
  ticker: {
    fontSize: '1.25rem',
    margin: 0,
    color: '#FAFF00',
  },
  contributions: {
    marginTop: '0.5rem',
    fontSize: '1rem',
    color: '#00FFFF',
  },
};

export default Leaderboard;
